import React, { useEffect } from 'react';
import UserProfile from '../components/MyGiftlist/UserProfile';
import useGlobal from '../store';
import MyGiftlist from '../components/Dashboard/MyGiftlist';
import MyAccount from '../components/Dashboard/MyAccount';
import MyArchive from '../components/Dashboard/MyArchive';
import MyProfile from '../components/Dashboard/MyProfile';
import LoadingOverlay from '../components/General/LoadingOverlay';
import Home from '../components/MyGiftlist/Home';

const MyGiftlistPage = (props) => {

    const [user] = useGlobal(
        state => state.user
    );
    const [giftlists] = useGlobal(
        state => state.giftlists
    );
    const [ui, uiActions] = useGlobal(
        state => state.ui.dashboard,
        actions => actions.uiActions
    );
    useEffect(() => {
        console.log('MY GIFTLIST');

    }, []);


    useEffect(() => {
        console.log('GIFTLISTS!', giftlists);
        if(!giftlists) {
            return;
        }
        console.log('GIFTLISTS!', giftlists);
        
    }, [giftlists]);

    
    const renderTab = () => {
        if(!user) {
            return <></>;
        }
        switch(ui.activeTab) {
            case "home":
                return <Home></Home>;
            case "mygiftlist":
                return <MyGiftlist></MyGiftlist>;
            case "myprofile":
                return <MyProfile user={user}></MyProfile>;
            case "myaccount":
                return <MyAccount></MyAccount>;
            case "myarchive":
                return <MyArchive></MyArchive>;
            default:
                return <></>;
        }
    }

    return (!user ? <div style={{minHeight:"300px"}} className="mt-5 kt-container kt-grid__item kt-grid__item--fluid"><LoadingOverlay height="10rem" width="10rem" color="primary" opacity="0.1"></LoadingOverlay></div> :
        <>
            <div className="kt-subheader kt-grid__item">
                <div className="kt-container">
                    <div></div>
                    <div className="kt-subheader__toolbar">
                        <div className="kt-subheader__wrapper">
                            <button onClick={() => uiActions.toggleSidePanel("additem", { selectedUser: user })} className="kt-hidden-desktop btn btn-wide btn-bold btn-success btn-upper">
                                <i className="flaticon2-plus-1"></i> Add Item
                            </button>
                            <button onClick={() => uiActions.toggleSidePanel("sharelists", { users: [user.userID] })} className="btn btn-wide btn-bold btn-info btn-upper">
                                <i className="flaticon2-send-1"></i> Share
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{minHeight:"300px"}} className="mt-0 kt-container kt-grid__item kt-grid__item--fluid">				
                    <div className="row">	
                        <div className="col-sm-12">
                            <UserProfile></UserProfile>
                        </div>
                    </div>	

                    {renderTab()}
     
            </div>
        </>);
}


export default MyGiftlistPage;